import { BsStarFill, BsTrash } from 'react-icons/bs';
import { Dispatch, FC, SetStateAction } from 'react';
import { typePreachingGroup, typeUser } from '@monorepo/models';
import { useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    group: typePreachingGroup;
    groupUser: typeUser;
    numberConfirmed: boolean;
    readOnly?: boolean;
    setGroups: Dispatch<SetStateAction<typePreachingGroup[] | null>>;
};

export const GroupsItemUser: FC<propsType> = ({ group, groupUser, numberConfirmed, readOnly, setGroups }) => {
    const isMobile = useGetIsMobile();

    return (
        <div className={'row border py-1'}>
            <div className={`col ${isMobile ? 'text-center my-2' : 'text-nowrap'} ps-2 ${!groupUser.groupIsTheOverseer && !groupUser.groupIsTheAssistance && isMobile ? 'mb-3' : ''}`}
                style={{ paddingTop: '2px' }}
            >
                <span className={isMobile ? 'fw-bolder' : ''}>
                    {groupUser.lastName}, {groupUser.name} {!readOnly && numberConfirmed && <>{isMobile ? <br /> : ' '}({groupUser.email})</>}
                </span>
            </div>
            <div className={`${(readOnly || !numberConfirmed) ? 'col-lg-2' : 'col-lg-1'} text-center ${isMobile && groupUser.groupIsTheOverseer ? 'mb-3' : ''}`}>
                {groupUser.groupIsTheOverseer && <><BsStarFill className={'me-1'} style={{ marginBottom: '2px' }} />{isMobile ? 'Superintendente del Grupo' : 'Sup.'}</>}
            </div>
            <div className={`${(readOnly || !numberConfirmed) ? 'col-lg-2' : 'col-lg-1'} text-center ${isMobile && groupUser.groupIsTheAssistance ? 'mb-3' : ''}`}>
                {groupUser.groupIsTheAssistance && <><BsStarFill className={'me-1'} style={{ marginBottom: '2px' }} />{isMobile ? 'Auxiliar del Grupo' : 'Aux.'}</>}
            </div>
            {!readOnly && numberConfirmed &&
                <div className={'col-lg-5'}>
                    <button className={`btn btn-sm btn-secondary ${isMobile ? 'w-100' : ''} me-2`}
                        onClick={() => {
                            setGroups(x => x!.map(_g => _g.numberOfGroup === group.numberOfGroup ? ({
                                ..._g,
                                users: group.users.map(_u => _u.id === groupUser.id ? ({
                                    ..._u,
                                    groupIsTheAssistance: false,
                                    groupIsTheOverseer: true
                                })
                                :
                                ({
                                    ..._u,
                                    groupIsTheOverseer: false
                                }))
                            }) : _g));
                        }}
                        disabled={!numberConfirmed || groupUser.groupIsTheOverseer}
                    >
                        <BsStarFill className={'me-1'} style={{ marginBottom: '2px' }} />{isMobile ? `Hacer Superintendente del Grupo ${group.numberOfGroup}` : 'Hacer S.I. de Grupo'}
                    </button>
                    {isMobile && <br />}
                    <button className={`btn btn-sm btn-secondary ${isMobile ? 'w-100 my-2' : ''} me-2`}
                        onClick={() => {
                            setGroups(x => x!.map(_g => _g.numberOfGroup === group.numberOfGroup ? ({
                                ..._g,
                                users: group.users.map(_u => _u.id === groupUser.id ? ({
                                    ..._u,
                                    groupIsTheAssistance: true,
                                    groupIsTheOverseer: false
                                })
                                :
                                ({
                                    ..._u,
                                    groupIsTheAssistance: false
                                }))
                            }) : _g));
                        }}
                        disabled={!numberConfirmed || groupUser.groupIsTheAssistance}
                    >
                        <BsStarFill className={'me-1'} style={{ marginBottom: '2px' }} />{isMobile ? `Hacer Auxiliar del Grupo ${group.numberOfGroup}` : 'Hacer Aux. de Grupo'}
                    </button>
                    {isMobile && <br />}
                    <button className={`btn btn-sm btn-danger ${isMobile ? 'w-100 mb-2' : ''}`}
                        onClick={() => {
                            const newGroup: typePreachingGroup = {
                                ...group,
                                users: group.users.filter(_u => _u.id !== groupUser.id)
                            };
                            setGroups(x => x!.map(_g => _g.numberOfGroup === group.numberOfGroup ? newGroup : _g));
                        }}
                        disabled={!numberConfirmed}
                    >
                        <BsTrash className={'me-1'} style={{ marginBottom: '2px' }} />Remover {isMobile && `del Grupo ${group.numberOfGroup}`}
                    </button>
                </div>
            }
        </div>
    );
}
